/**
 * Breakpoints synced with `src/assets/styles/tailwind.css` (`@theme --breakpoint-*`)
 * and `src/assets/styles/base/breakpoints/_breakpoints.scss`.
 *
 * Values are min-width thresholds (mobile-first), same as Tailwind / CSS media queries.
 */
export const BREAKPOINTS = {
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
  xxl: 2560,
  '2xl': 2560,
} as const;

export type BreakpointName = keyof typeof BREAKPOINTS | 'xs';

/**
 * Vuetify 2 `breakpoint` preset derived from the same Tailwind values.
 *
 * Vuetify thresholds are upper bounds of each named range:
 * - xs: width < sm
 * - sm: sm <= width < md
 * - md: md <= width < lg
 * - lg: lg <= width < xl
 * - xl: width >= xl
 *
 * `scrollBarWidth: 0` keeps JS checks aligned with Tailwind CSS (no scrollbar offset).
 * `mobileBreakpoint` matches common `smAndDown` usage (width < md).
 */
export const VUETIFY_BREAKPOINT_CONFIG = {
  scrollBarWidth: 0,
  mobileBreakpoint: BREAKPOINTS.md,
  thresholds: {
    xs: BREAKPOINTS.sm,
    sm: BREAKPOINTS.md,
    md: BREAKPOINTS.lg,
    lg: BREAKPOINTS.xl,
  },
} as const;
